<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">Pacientes</div>
<!--  <div class="mr-8">-->
<!--    <button mat-raised-button class="btn-add" (click)="newPatient()">-->
<!--      Novo-->
<!--    </button>-->
<!--  </div>-->
</div>

<div class="mt-4">
  <!-- Barra de pesquisa -->
  <form-patient-search
    [search]="inputSearch"
    [listSearch]="listSearch"
    (responseSearch)="search($event)"
  />

  <div *ngIf="!loading; else loadingTemplate">
    <!-- Principais pacientes -->
    <div class="flex gap-6 flex-wrap justify-between mb-8">
      <div class="paciente-card" *ngFor="let paciente of pacientes">
        <div
          class="circle-wrapper"
          (click)="viewItem(paciente)"
          [ngStyle]="{ 'background-image': getBorderGradient(paciente.exame) }"
        >
          <div class="circle-inner">
            <img src="/images/10870645.png" alt="ícone padrão" />
          </div>
        </div>

        <div class="info text-center mt-2">
          <p class="font-bold">{{ paciente.nome_paciente }}</p>

          <!-- mostra todos os exames -->
          <div *ngFor="let exame of paciente.exame">
            <p>{{exame.exame}}</p>
            <p>{{ exame.nivel_urgencia }}</p>
            <p *ngIf="exame.valor_glicose">
              {{ exame.valor_glicose }} {{ exame.tipo_unidade }}
            </p>
            <mat-divider class="my-2"></mat-divider>
          </div>

          <p>Unidade de Saúde: {{ paciente.unidade_saude }}</p>
        </div>
      </div>
    </div>
  </div>


  <!-- Loading -->
  <ng-template #loadingTemplate>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-template>
</div>
